import {AfterViewInit, Component, OnInit} from '@angular/core';
import {
    ControlService,
    IconService,
    ParametersService,
    SendDataService,
    SubtitlesService,
    TimeDateService
} from "../../../core";
import {MenuElementParamsType109, MenuElementType109, MenuType} from "../../../models";

@Component({
    selector: 'date-format-control',
    templateUrl: './date-format-control.component.html',
    styleUrls: ['./date-format-control.component.scss']
})
export class DateFormatControlComponent implements OnInit, AfterViewInit {
    newDate: string = '';
    displayDate: string = '';
    editable: boolean = false;
    format: 1 | 2 = 2;

    constructor(
        public control: ControlService,
        private icon: IconService,
        private parameters: ParametersService,
        private sendData: SendDataService,
        private subtitles: SubtitlesService,
        public timeDate: TimeDateService,
    ) {
    }

    ngOnInit() {
        const elementVal = this.control.elementVal.getValue() as MenuElementType109;
        const params = elementVal?.params;

        const parsed = this.parseParams(params);
        this.format = parsed.format;
        this.editable = parsed.editable;
        const parts = parsed.parts;
        this.setDateFromParts(parts.day, parts.month, parts.year);
    }

    ngAfterViewInit() {
        this.control.setOverflow();
    }

    setIcon(val: number | MenuType): string {
        if (val === null) return;

        return this.icon.setIcon(val);
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }

    setDate(date: string): void {
        this.newDate = date;
    }

    setDateNow(): void {
        const now = new Date();
        this.newDate = `${now.getFullYear()}-${this.timeDate.double(now.getMonth() + 1)}-${this.timeDate.double(now.getDate())}`;
    }

    setDateFromParams(): void {
        const elementVal = this.control.elementVal.getValue() as MenuElementType109;
        const parts = this.parseParams(elementVal?.params).parts;
        this.setDateFromParts(parts.day, parts.month, parts.year);
    }

    sendDate(): void {
        const elementVal = this.control.elementVal.getValue() as MenuElementType109;
        if (!elementVal) return;

        const parts = this.parseDateParts(this.newDate);
        const values = this.format === 1
            ? [parts.day, parts.month]
            : [parts.day, parts.month, parts.year];

        if (!elementVal.params) {
            elementVal.params = {
                editable: this.editable ? 1 : 0,
                format: this.format,
                values: []
            };
        }

        elementVal.params.values = values;
        elementVal.params.format = this.format;
        if ('day' in elementVal.params) elementVal.params['day'] = parts.day;
        if ('month' in elementVal.params) elementVal.params['month'] = parts.month;
        if ('year' in elementVal.params) elementVal.params['year'] = parts.year;

        this.control.elementVal.next(elementVal);
        this.returnFormatDate(values, this.format);
    }

    private setDateFromParts(day: number, month: number, year: number): void {
        const safeYear = Number.isFinite(year) ? year : new Date().getFullYear();
        this.newDate = `${safeYear}-${this.timeDate.double(month)}-${this.timeDate.double(day)}`;
        this.setDisplayDate(day, month, safeYear);
    }

    private setDisplayDate(day: number, month: number, year: number): void {
        const dd = this.timeDate.double(day);
        const mm = this.timeDate.double(month);
        this.displayDate = this.format === 1
            ? `${dd}-${mm}`
            : `${dd}-${mm}-${year}`;
    }

    private parseDateParts(date: string): {day: number, month: number, year: number} {
        const [year, month, day] = date.split('-').map(Number);
        return {
            day: Number.isFinite(day) ? day : 1,
            month: Number.isFinite(month) ? month : 1,
            year: Number.isFinite(year) ? year : new Date().getFullYear()
        };
    }

    private parseParams(params: MenuElementParamsType109 | undefined): {
        editable: boolean,
        format: 1 | 2,
        parts: {day: number, month: number, year: number}
    } {
        const now = new Date();

        const values = params?.values ?? [];
        const editable = params?.editable === 1 || (params as any)?.edit === 1;
        const format = params?.format === 1 ? 1 : 2;
        const day = values[0] ?? params?.day ?? now.getDate();
        const month = values[1] ?? params?.month ?? (now.getMonth() + 1);
        const year = values[2] ?? params?.year ?? now.getFullYear();

        return {
            editable,
            format,
            parts: {day, month, year}
        };
    }

    private returnFormatDate(values: number[], format: 1 | 2): void {
        const elementVal = this.control.elementVal.getValue() as MenuElementType109 | undefined;
        const element = this.control.element.getValue() as MenuElementType109 | undefined;
        const day = values[0] ?? -1;
        const month = values[1] ?? -1;
        const year = format === 2 ? (values[2] ?? -1) : -1;

        const dataToSend = {
            menuType: elementVal?.menuType,
            ido: elementVal?.id,
            data: format === 1
                ? {day, month}
                : {day, month, year}
        };

        this.sendData.sendControlData(dataToSend);

        if (!this.parameters.demoAccount()) {
            if (element) {
                if (!element.params) {
                    element.params = {
                        editable: 0,
                        format,
                        values: []
                    };
                }

                element.params.format = format;
                element.params.values = format === 1 ? [day, month] : [day, month, year];
                element.duringChange = 't';
                this.control.setsNewValue = elementVal?.id ?? 0;
                this.control.hideControl();
            }
        }
    }
}
